import type { AccountStatus } from "../hooks/useAuthState";

export type AccountGate = "app" | "pending" | "disabled";

export function getAccountGate(role: string, status: AccountStatus): AccountGate {
  if (status === "disabled") return "disabled";
  if (status !== "active" || role === "unassigned") return "pending";
  return "app";
}
